import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'vc-gallery-markup',
  templateUrl: './gallery-markup.component.html',
  styleUrls: ['./gallery-markup.component.scss'],
  // Can cause bug on transitions / animation if removed.
  encapsulation: ViewEncapsulation.None
})
export class GalleryMarkupComponent {}
